<!--
 * @Descripttion: 
 * @version: 
 * @Author: JumpingBirds
 * @Date: 2020-08-03 13:01:54
 * @LastEditors: JumpingBirds
 * @LastEditTime: 2020-09-09 10:21:42
-->
<template>
  <div>
    <div class="box news-box">
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/monitoringIndex' }">监督监测</el-breadcrumb-item>
          <el-breadcrumb-item></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="detail-wrapper" id="printTest">
        <div class="detail-title">{{form.title}}</div>
        <div class="detail-title-sub">
          <span v-if="form.publishUser">发布单位：{{form.publishUser}}</span>
          <span>时间：{{form.publishTime}}</span>
        </div>
        <div class="detail-content" v-html="safeContent"></div>
      </div>
      <div v-if="form.enclosure && form.enclosureName" style="    padding: 0 77px;">
        附件：<a v-for="(item,index) in form.enclosure.split(',')" :key="index" download="img" style="color:rgba(1,173,214,1);text-decoration: underline;" :href="publicPath+item">{{ index == form.enclosureName.split(',').length-1 ? form.enclosureName.split(',')[index] : form.enclosureName.split(',')[index]+"，"}} </a>
      </div>
      <div class="opts">
        <a href="javascript:void(0);" class="b-print" v-print="printObj">打印本文章</a>
        <a  class="b-share b-share-weixin -mob-share-weixin" ></a>
        <a  class="b-share b-share-webo -mob-share-weibo"></a>



      </div>
    </div>
  </div>
</template>
<script>

import { getMonitoringById } from "../../api/index.js";
import DOMPurify from 'dompurify';
export default {
  data() {
    return {
      publicPath:window.publicPath,
      form: {
        publishUser: "",
        textContent: "",
        publishTime: "",
        title: "",
        sort: "",
        stick: 0,
        id: null,
        delFlag: 0
      },
      printObj: {
        id: '#printTest',
        popTitle: '河南省水土保持',
        type: 'html',
      }
    };
  },computed: {
    safeContent() {
      if (!this.form.textContent) return '';
      // 净化配置：删除事件、javascript伪链接，只保留安全富文本标签
      return DOMPurify.sanitize(this.form.textContent, {
        // 禁止所有on*事件处理器 onerror/onclick/onload等
        FORBID_ATTR: [/^on.*/],
        // 禁止 javascript: 伪协议
        ALLOWED_UNKNOWN_PROTOCOLS: false,
        // 按需：如果新闻里有视频/iframe，默认会删掉iframe，需要的话再配置ADD_TAGS:['iframe']
        ADD_TAGS: [],
        ADD_ATTR: []
      });
    }
  },
  created() {
    this.form.id = this.$route.params.id;
    if (this.form.id) {
      this.title = "编辑";
      this.getOne();
    }

  },
  mounted(){
        let script = document.createElement('script')
script.type = 'text/javascript'
script.src = 'http://f1.webshare.mob.com/code/mob-share.js?appkey=2f0d5f822e505'
script.id = '-mob-share'
document.body.appendChild(script)
  },
  methods: {
    getOne() {
      getMonitoringById({
        id: this.form.id
      }).then(res => {
        if (res.flag) {
          this.form = res.data;
        }
      });
    }
  }
};
</script>

<style lang="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/monitoring/detail.vue